import React from "react";
import Icon from "./Icon";
import KebabMenu from "../../../components/KebabMenu";

/**
 * One document as a row: a file-type tile, title with its description and details, and actions. Everyone gets
 * Download/Open; editors also get a Publish / Turn off button. `menuItems` are the overflow actions
 * ({ icon, label, danger, onSelect }). `titleSlot` replaces the title while a Knowledge Bank copy is renamed.
 */
export default function DocRow({
  model, canEdit, onOpen, onTogglePublish, publishing, menuItems, titleSlot, extraAction,
  reorder, dragProps, dragging, dropOver,
}) {
  const { tile } = model;
  const cls = ["doc", dragging ? "dragging" : "", dropOver ? "ins-b" : "", model.published ? "" : "unpub"].filter(Boolean).join(" ");
  return (
    <div className={cls} data-testid={`doc-row-${model.source}-${model.id}`} {...dragProps}>
      <span className={`tile ${tile.cls}`} aria-hidden="true">
        {tile.icon ? <Icon n={tile.icon} s={17} /> : <b>{tile.text}</b>}
      </span>

      <div className="main">
        {titleSlot || (
          <>
            <h3>
              <span title={model.title}>{model.title}</span>
              {canEdit && !model.published && <em className="pill draft">Draft</em>}
              {model.fromBank && <em className="pill bank">From Bank</em>}
              {model.featured && <em className="pill feat">Featured</em>}
              {model.instructorViewOnly && <em className="pill">Instructor view only</em>}
              {model.inLearningPlan && <em className="pill locked"><Icon n="lock" s={11} />In Learning Plan</em>}
            </h3>
            {model.description && <p className="desc">{model.description}</p>}
          </>
        )}
        <div className="meta">
          <span className="mu">{model.info}</span>
          {model.required && <span>Required</span>}
          {!model.published && <span className="hid"><Icon n="eyeOff" />Hidden from students</span>}
          {model.updated && <span className="mu">Updated {model.updated}</span>}
        </div>
      </div>

      <div className="acts">
        {reorder && (
          <span className="reorder">
            <button type="button" aria-label={`Move ${model.title} up`} disabled={reorder.upDisabled} onClick={reorder.onUp}><Icon n="up" s={13} /></button>
            <button type="button" aria-label={`Move ${model.title} down`} disabled={reorder.downDisabled} onClick={reorder.onDown}><Icon n="down" s={13} /></button>
          </span>
        )}
        {extraAction}
        {model.primary && (
          <button type="button" className="btn btn-o btn-sm" aria-label={`${model.primary === "open" ? "Open" : "Download"} ${model.title}`} onClick={onOpen}>
            <Icon n={model.primary === "open" ? "ext" : "download"} />
            {model.primary === "open" ? "Open" : "Download"}
          </button>
        )}
        {canEdit && (model.published ? (
          <button type="button" className="btn btn-o btn-sm" disabled={publishing} onClick={onTogglePublish}><Icon n="eyeOff" />Turn off</button>
        ) : (
          <button type="button" className="btn btn-p btn-sm" disabled={publishing} onClick={onTogglePublish}><Icon n="eye" />Publish</button>
        ))}
        {menuItems.length > 0 && (
          <KebabMenu label={`More actions for ${model.title}`} triggerIcon={<Icon n="more" s={16} />} items={menuItems} />
        )}
      </div>
    </div>
  );
}
